import {Component, ElementRef, EventEmitter, HostListener, Inject, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild,} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ProductListing} from 'src/app/raintree/interface/product-listing/product-listing';
import {ProductListingTransmissionService} from 'src/app/raintree/transmission/product-listing/product-listing-transmission.service';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {FabricFilterService} from '../../product-filter-sidebar/service/fabric-filter.service';
import {Subscription} from 'rxjs';
import {animate, style, transition, trigger} from '@angular/animations';
import {UntilDestroy} from '@ngneat/until-destroy';
import {ProductListPriceCalculationService} from "../../service/product-list-price-calculation.service";
import {isPlatformBrowser} from '@angular/common';
import {WishlistService} from "../../../wishlist/wishlist.service";
import {ApCurrency} from "../../../pipe/enum/ap-currency";
import {CurrencyResolverService} from "../../../currency-resolver.service";

@UntilDestroy()
@Component({
	selector: 'fb-product-listing',
	animations: [
		trigger('enterAnimation', [
			transition(':enter', [
				style({ transform: 'translateX(0)', opacity: 0 }),
				animate(
					'200ms',
					style({ transform: 'translateX(0)', opacity: 1 })
				),
			]),
			transition(':leave', [
				style({ transform: 'translateX(0)', opacity: 1 }),
				animate(
					'200ms',
					style({ transform: 'translateX(0)', opacity: 0 })
				),
			]),
		]),
	],
	templateUrl: './product-listing.component.html',
	styleUrls: ['./product-listing.component.scss'],
})
export class ProductListingComponent implements OnInit, OnDestroy {
	constructor(
		private _activatedRoute: ActivatedRoute,
		private _productListingTransmissionService: ProductListingTransmissionService,
		private _filterService: FabricFilterService,
		private _productListingPriceCalculation: ProductListPriceCalculationService,
		private _wishlist: WishlistService,
		private _currencyResolver: CurrencyResolverService,
		@Inject(PLATFORM_ID) private _platformId: Object
	) {
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	@ViewChild('testDiv', { static: false })
	private testDiv: ElementRef<HTMLDivElement> =
		{} as ElementRef<HTMLDivElement>;

	@Output()
	public productList:EventEmitter<ProductListing[]> = new EventEmitter<ProductListing[]>();
	isTestDivScrolledIntoView: boolean = false;
	public subscription: Subscription[] = [];
	public productListing: ProductListing[] = [];
	public sortShow: boolean = false;
	public productListingForView: ProductListing[] = [];
	public isBrowser: boolean = false;
	public currentPageNumber: number = 1;
	public numberOfItemPerPage: number = 9;
	public startIndex: number = 0;
	public endIndex: number = this.startIndex + this.numberOfItemPerPage;
	public isLoading: boolean = true;
	public selectedSortOption: string = 'date';
	public selectedCurrency: ApCurrency = ApCurrency.USD;

	public openSortOption(): void {
		this.sortShow ? (this.sortShow = false) : (this.sortShow = true);
	}

	public sort(type: string): void {
		let productListing: ProductListing[] = [];

		if (type == 'date'){

			productListing = this.productListing.sort(
				(a:ProductListing, b:ProductListing) =>
					b.product.id - a.product.id
			);
			this.selectedSortOption = 'date';
		}


		if (type == 'l_t_h'){

			productListing = this.productListing.sort(
				(a:ProductListing, b:ProductListing) => a.product.price - b.product.price
			);

			this.selectedSortOption = 'l_t_h';
		}


		if (type == 'h_t_l') {

			productListing = this.productListing.sort(
				(a:ProductListing, b:ProductListing) => b.product.price - a.product.price
			);

			this.selectedSortOption = 'h_t_l';
		}


		this.productListingForView = productListing.slice(0, 9);
	}

	public getProductList(url: string): void {
		this._productListingTransmissionService.getProductList(
			url,

			(): void => {},

			(): void => {
			},

			(response: ProductListing[]): void => {
				if (response.length < 1) {
					this.isLoading = false;
				} else {
					this.productListing = response;

					this.productListing = this.productListing.sort(
						(a:ProductListing, b:ProductListing) => b.product.id - a.product.id
					);
					this.checkInWishlist();
					this.productListing = this._productListingPriceCalculation.calculateListingPriceForFinishedProduct(response);

					this.productListingForView = this.productListing.slice(
						this.startIndex,
						this.numberOfItemPerPage
					);
				}

				this.productList.emit(this.productListing);
				this.isLoading = false;

				this.loadMore();
			},

			(): void => {
				this.isLoading = false;
			},

			(): void => {}
		);
	}

	public loadMore(): void {
		this.productListingForView = [
			...this.productListingForView,
			...this.productListing.slice(this.startIndex, this.endIndex),
		];
	}

	public loadMoreClicked(): void {
		// this.productShowing += 9;
		this.currentPageNumber += 1;
		this.startIndex =
			(this.currentPageNumber - 1) * this.numberOfItemPerPage;
		this.endIndex = this.startIndex + this.numberOfItemPerPage;

		this.loadMore();
	}

	public getProductListInStoryDetails(url: string, id: string): void {
		this._productListingTransmissionService.getProductList(
			url + id,

			(): void => {},
			(): void => {},
			(response: ProductListing[]): void => {
				this.productListing = response;

				this.productListing = this.productListing.sort(
					(a:ProductListing, b:ProductListing) => b.product.id - a.product.id
				);
				this.checkInWishlist();
				this.productListing = this._productListingPriceCalculation.calculateListingPriceForFinishedProduct(response);
				this.productListingForView = this.productListing.slice(
					this.startIndex,
					this.numberOfItemPerPage
				);

				this.productList.emit(this.productListing);
				this.isLoading = false;
			},
			(): void => {},

			(): void => {}
		);
	}

	public ngOnInit(): void {
		const filterSubs:Subscription = this._filterService.filteredData.subscribe(
			(ProductListing: ProductListing[]): void => {
				this.productListing = ProductListing;

				this.startIndex = 0;
				this.currentPageNumber = 1;

				this.startIndex = 0;
				this.endIndex = this.startIndex + this.numberOfItemPerPage;
				this.checkInWishlist();
				this.productListingForView = [];
				this.loadMore();
				// this.productShowing = 0;
			}
		);
		this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		this._currencyResolver.selectCurrencyChange.subscribe(() => {
			this.selectedCurrency = this._currencyResolver.getSelectedCurrency();
		});

		this.subscription.push(filterSubs);

		this._activatedRoute.params.subscribe((params): void => {
			if (params['category'] === 'finished') {
				this.getProductList(
					RequestMapperService.GET_PRODUCT_LISTING_FINISHED
				);
			}

			if (params['category'] === 'fabric') {
				this.getProductList(
					RequestMapperService.GET_PRODUCT_LISTING_FABRIC
				);
			}

			// debugger
			if (this.isBrowser) {
				if (window.location.href.includes('/story-details/')) {
					// debugger
					this.getProductListInStoryDetails(
						RequestMapperService.GET_RELATED_STORY_PRODUCT,
						params['id']
					);
				}
			}

		});
	}

	private checkInWishlist(): void {
		this.productListing.forEach((product) => {
			product.inWishlist = this._wishlist.isInWishlist(product.product.sku);
		});
	}

	public ngOnDestroy(): void {
		this.subscription.forEach((subs: Subscription): void => {
			subs.unsubscribe();
		});
	}

	@HostListener('window:scroll', ['$event'])
	public isScrolledIntoView(): void {
		if (this.testDiv ) {
			if(this.isBrowser){
				const rect:DOMRect = this.testDiv.nativeElement.getBoundingClientRect();
				const topShown: boolean = rect.top >= 0;
				const bottomShown: boolean = rect.bottom <= window.innerHeight;
				this.isTestDivScrolledIntoView = topShown && bottomShown;
			}


			if (this.isTestDivScrolledIntoView) {
				this.loadMoreClicked();
			}
		}
	}
}
